import { styled } from '@mui/material/styles';

export const UlStyled = styled('ul')({
  paddingLeft: '26px',
  marginBottom: '16px',
});

export const OlStyled = styled('ol')({
  paddingLeft: '26px',
  marginBottom: '16px',
  '& ::marker': {
    fontWeight: 500,
  },
});
